import en from './PersonalInfoTranslations.en';

export default {
  en,
};
